export const EDITOR_MODE = {
    GENERATE_SUBTITLES_MODE: 0,
    EDIT_SUBTITLES_MODE: 1,
    TRANSLATE_SUBTITLES_MODE: 2,
};

export const MISSING_MODE = {
    TRANSCRIPTION: 'transcription',
    TRANSLATION: 'translation',
};

export const NON_LANDSCAPE_COEF_FONT_SIZE = 0.75;

export const BASE_PLAYER_HEIGHT = 650;

export const MAX_WIDTH_SUBTITLES_LANDSCAPE = 0.65;

export const BASE_FONT_SIZE = 24;

export const INIT_SUBTITLES_POSITION = 15;

export const TIME_CORRECTION_STEP = 200;

export const DEFAULT_SUBTITLE_SETTINGS = {
    fontId: 52,
    fontSize: BASE_FONT_SIZE,
    textColor: '#FFFFFF',
    backgroundColor: '#000000bf',
    textShadow: false,
    textOutlineColor: null,
};

export const FINAL_MODE = 'final';

export const VOICEOVER_COVERAGE_TYPES = {
    START: 'start',
    END: 'end',
    FULL: 'full',
    INTERMEDIATE: 'intermediate',
}